<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.51699 2.36664L3.02533 5.86664C2.27533 6.44997 1.66699 7.69164 1.66699 8.63331V14.8083C1.66699 16.7416 3.24199 18.325 5.17533 18.325H14.8253C16.7587 18.325 18.3337 16.7416 18.3337 14.8166V8.74997C18.3337 7.74164 17.6587 6.44997 16.8337 5.87497L11.6837 2.26664C10.517 1.44997 8.64199 1.49164 7.51699 2.36664Z" stroke="url(#paint0_linear_7286_2242)" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M10 14.9917V12.4917" stroke="url(#paint1_linear_7286_2242)" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
    <defs>
      <linearGradient id="paint0_linear_7286_2242" x1="-0.985834" y1="-12.3043" x2="26.4799" y2="-7.32206" gradientUnits="userSpaceOnUse">
        <stop stop-color="#FECBD4" />
        <stop offset="0.345047" stop-color="#EB008B" stop-opacity="0.8" />
        <stop offset="0.857321" stop-color="#AA0085" stop-opacity="0.85" />
        <stop offset="1" stop-color="#8A008A" />
      </linearGradient>
      <linearGradient id="paint1_linear_7286_2242" x1="9.84083" y1="10.391" x2="11.5341" y2="10.5137" gradientUnits="userSpaceOnUse">
        <stop stop-color="#FECBD4" />
        <stop offset="0.345047" stop-color="#EB008B" stop-opacity="0.8" />
        <stop offset="0.857321" stop-color="#AA0085" stop-opacity="0.85" />
        <stop offset="1" stop-color="#8A008A" />
      </linearGradient>
    </defs>
  </svg>
</template>
